import { ADMIN_MENU } from "../config/adminMenu";
import { canAccessRoute, getAdminRoleId } from "../config/adminPermissions";

export const getVisibleAdminMenu = (admin) => {
    const rid = getAdminRoleId(admin);

    return ADMIN_MENU
        .filter((section) => section.allowedRoles.includes(rid))
        .map((section) => {
            const items = section.items
                .map((item) => {
                    if (item.type === "group") {
                        const visibleChildren = item.children.filter((child) =>
                            canAccessRoute(admin, child.routeKey)
                        );

                        return {
                            ...item,
                            children: visibleChildren,
                        };
                    }

                    return item;
                })
                .filter((item) => {
                    if (item.type === "group") {
                        return item.children.length > 0;
                    }

                    return canAccessRoute(admin, item.routeKey);
                });

            return {
                ...section,
                items,
            };
        })
        .filter((section) => section.items.length > 0);
};